export const DEBT_WALLET_ID = '__virtual_debt_wallet__';
export const CREDIT_WALLET_ID = '__virtual_credit_wallet__';

export const VIRTUAL_DEBT_WALLETS = [
  {
    id: DEBT_WALLET_ID,
    name: 'Debito',
    color: '#ef4444',
    isVirtual: true
  },
  {
    id: CREDIT_WALLET_ID,
    name: 'Credito',
    color: '#10b981',
    isVirtual: true
  }
];
